import { store } from '../store';

const getRiskColumnsByLanguage = (languageName) => {
  if (languageName === "English") {
    return {
      work_phase: 'work_phase_or_ambient_exposure',
      activity: 'activity',
      hazard: 'hazard',
      unwanted_event: 'unwanted_event'
    }
  } else {
    const languageNameLower = languageName.toLowerCase()
    return {
      work_phase: `work_phase_${languageNameLower}`,
      activity: `activity_${languageNameLower}`,
      hazard: `hazard_${languageNameLower}`,
      unwanted_event: `unwanted_event_${languageNameLower}`
    }
  }
}

const getFormLabelTranslations = () => {
  const { instance, language } = store.getState();
  const { enabled_languages: enabledLanguages } = instance.instanceConfig;
  const { work_phase_or_ambient_exposure, activity, hazard, unwanted_event } = language.language.translations;
  const formLabelTranslations = {}
  for (const language of enabledLanguages) {
    if (language !== "English") {
      const languageNameLower = language.toLowerCase();
      formLabelTranslations[`work_phase_${languageNameLower}`] = work_phase_or_ambient_exposure;
      formLabelTranslations[`activity_${languageNameLower}`] = activity;
      formLabelTranslations[`hazard_${languageNameLower}`] = hazard;
      formLabelTranslations[`unwanted_event_${languageNameLower}`] = unwanted_event;
    } else {
      formLabelTranslations["work_phase_or_ambient_exposure"] = work_phase_or_ambient_exposure;
      formLabelTranslations["activity"] = activity;
      formLabelTranslations["hazard"] = hazard;
      formLabelTranslations["unwanted_event"] = unwanted_event;
    }
  }

  return formLabelTranslations
}

const getLanguageOptions = () => {
  const { instance } = store.getState();
  const { enabled_languages: enabledLanguages, supported_languages: supportedLanguages } = instance.instanceConfig;
  return supportedLanguages ? supportedLanguages.filter((item)=>{return enabledLanguages.includes(item.value)}) : [];
}

function getLanguageLabel(language) {
  if (!language) return;
  const languages = getLanguageOptions();
  const languageDetail = languages.find(({ value }) => language.toLowerCase() === value.toLowerCase());
  return languageDetail && languageDetail.text;
}

const getKeyByValue = (object, value) => {
  return Object.keys(object).find(key => object[key] === value);
}

const getText = (text) => {
  const { language } = store.getState();
  const { name: selectedLanguage, translations: selectedLanguageTranslations } = language.language;

  if (selectedLanguage === "English") return text;

  const { englishTranslations } = language;
  const translationKey = getKeyByValue(englishTranslations, text);

  return (selectedLanguageTranslations[translationKey] || text);
}

export {
  getRiskColumnsByLanguage,
  getFormLabelTranslations,
  getLanguageOptions,
  getLanguageLabel,
  getText
}


// WEBPACK FOOTER //
// ./src/helpers/language_helpers.js